import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Gibraltar: Country = {
    identifier: "Gibraltar",
    name: "Gibraltar",
    countryCode: "GI",
    group: CountryGroup.EUROPE,
    isUNMember: false,
    flag: "🇬🇮",
    svgPath: "m 459.92475,354.5694 -0.009,0.047 0.005,0.034 -0.007,0.094 -0.019,-0.002 -0.032,-0.048 0.003,-0.065 0.031,-0.017 -0.021,-0.04 z",
}
